<template>
  <div class="my-carto">
    <p class="title">{{ dataResult && dataResult.value }}</p>
    <div v-html="dataResult.explainContent"></div>
    <ul class="menu" v-if="dataResult.value && this.hospitalName && this.createTime">
        <li class="menu-li">
            <p class="li-title">姓名：</p>
            <p class="li-desc">{{ userInfo && userInfo.realName }}</p>
        </li>
        <li class="menu-li">
            <p class="li-title">医院名称：</p>
            <p class="li-desc">{{ hospitalName  }}</p>
        </li>
        <li class="menu-li">
            <p class="li-title">日期：</p>
            <p class="li-desc">{{ $moment(parseInt(this.createTime)).format('YYYY-MM-DD HH:mm')  }}</p>
        </li>
    </ul>
    <div class="btn" @click="handleClose" v-if="dataResult.value">关闭</div>
    <returnBack></returnBack>
  </div>
</template>

<script>
import returnBack from '@/views/person/components/returnBack.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import { getDataDictionary } from '@/api/person'
const UserProfile = {
  name: 'cartoDictonary',
  components: {
    returnBack
  },
  data () {
    return {
      dataResult: '',
      hospitalName: '',
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    this.hospitalName = this.$route.query.hospitalName
    this.createTime = this.$route.query.createTime
    this.onLoad()
  },
  methods: {
    onLoad() {
      getDataDictionary({
        typeCode: 'PRIVACYAGREEMENT',
        dataStatus: 1
      }).then(res => {
        if (res.code === 0) {
          let dataResult1 = res.data.filter(itm => itm.code === 'RemoteTeaching')
          this.dataResult = dataResult1 && dataResult1.length > 0 ? dataResult1[0] : ''
        }
      })
    },
    handleClose() {
      this.$router.back()
    },
  }
}

export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.my-carto{
    padding:24px 14px 26px 16px;
    .title{
        margin-bottom: 16px;
        text-align: center;
        font-size: 18px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        color: #222528;
    }
    .menu{
        margin:20px 0 40px;
        .menu-li{
            display: flex;
            align-items: center;
            color: #45555f;
            margin-bottom: 18px;
            .li-title{
                width: 30%;
            }
            .li-desc{
                flex: 1;
                border-bottom: 1px solid #45555f;
            }
        }
    }
    .btn{
        margin: 0 auto;
        width: 130px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        border-radius: 20px 20px 20px 20px;
        background: #EB1700;
        box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/person/cartoDictonary.vue